import React, { createRef, useEffect } from 'react';
import $ from 'jquery';
import PropTypes from 'prop-types';

import exportWithBoundary from '../helpers/exportWithBoundary';

function Tooltip(props) {
  const {
    className,
    tipText,
    children,
    placement,
    container,
    trigger,
    inlineText,
  } = props;
  const tipRef = createRef();

  useEffect(() => {
    $(tipRef.current).tooltip({
      container,
      placement,
      trigger,
      html: true,
      template:
        '<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
    });
  }, []);

  return (
    <>
      <span
        className={`${inlineText ? 'tooltip-inline-text' : ''} ${className}`}
        ref={tipRef}
        title={tipText}
      >
        {children}
      </span>
    </>
  );
}

Tooltip.defaultProps = {
  className: '',
  placement: 'top',
  container: 'body',
  trigger: 'hover',
  inlineText: false,
};

Tooltip.propTypes = {
  className: PropTypes.string,
  tipText: PropTypes.node.isRequired,
  placement: PropTypes.string,
  container: PropTypes.string,
  trigger: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  inlineText: PropTypes.bool,
};

// eslint-disable-next-line react/prop-types
function TooltipFallback({ children }) {
  return <>{children || []}</>;
}

export default exportWithBoundary(Tooltip, TooltipFallback);
